<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='layoutId ? "Редактирование планировки" : "Добавление планировки"'
  )
    template(slot='extension')
      s-back-btn
      v-btn(
        @click='onSave'
        :loading='isLoading'
        color='primary'
        class="mr-0"
        depressed
      ) Сохранить
  v-tabs(color='dark' slider-color='primary')
    v-tab Планировка
    v-tab-item(:transition='false' :reverse-transition='false')
      v-card
        v-container(grid-list-xl fluid)
          v-layout(wrap)
            v-flex(xs12)
              v-text-field(
                :error='errors.has("layout_name")'
                :error-messages='errors.first("layout_name")'
                v-model='item.layout_name'
                label='Название планировки'
              )
            v-flex(xs12 sm6)
              s-complex-picker(
                @change='objectChange'
                :error='errors.has("complex_id")'
                :error-messages='errors.first("complex_id")'
                label='Комплекс'
                v-model='item.complex_id'
              )
            v-flex(xs12)
              s-object-picker(
                :error='errors.has("object_ids")'
                :error-messages='errors.first("object_ids")'
                :filter='x => x.complex_id == item.complex_id'
                label='Выберите объект'
                v-model='item.object_ids'
                clearable
                multiple
                chips
              )
            v-flex(xs6)
              v-text-field(
                :error='errors.has("pano_link")'
                :error-messages='errors.first("pano_link")'
                v-model='item.pano_link'
                label='Ссылка на 3D панораму'
              )
            v-flex(xs6)
              s-file-upload(
                v-model='item.pdf_for_print',
                :file='item.pdf_for_print_url',
                :record-id='item.id',
                :parseResponse='(v) => v.hash',
                @remove-success='onRemovePDF',
                label='PDF для выводна на печать'
              )
            v-flex(xs12 sm3)
              v-text-field(
                :error='errors.has("rooms_count")'
                :error-messages='errors.first("rooms_count")'
                v-model='item.rooms_count'
                label='Количество комнат'
              )
            v-flex(xs12 sm3)
              v-text-field(
                :error='errors.has("square_total")'
                :error-messages='errors.first("square_total")'
                v-model='item.square_total'
                label='Общая площадь'
              )
            v-flex(xs12 sm3)
              v-text-field(
                :error='errors.has("square_living")'
                :error-messages='errors.first("square_living")'
                v-model='item.square_living'
                label='Жилая площадь'
              )
            v-flex(xs12 sm3)
              v-text-field(
                :error='errors.has("square_kitchen")'
                :error-messages='errors.first("square_kitchen")'
                v-model='item.square_kitchen'
                label='Площадь кухни'
              )
            v-flex(xs12 sm4)
              v-text-field(
                :error='errors.has("sections")'
                :error-messages='errors.first("sections")'
                v-model='item.sections'
                label='Для каких подъездов (через запятую)'
              )
            v-flex(xs12 sm4)
              v-text-field(
                :error='errors.has("floors")'
                :error-messages='errors.first("floors")'
                v-model='item.floors'
                label='Для каких этажей (через запятую)'
              )
            v-flex(xs12 sm4)
            v-flex(xs12 sm2)
              s-image-upload(
                :ratio='1'
                :src='item.placement_scheme_url'
                v-model='item.placement_scheme'
                label='Проектная планировка'
              )
            v-flex(xs12 sm2 style="background-color: #ebfbe9")
              s-image-upload(
                :ratio='1'
                :src='item.placement_sizing_url'
                v-model='item.placement_sizing'
                label='Линейные размеры'
              )
            v-flex(xs12 sm2)
              s-image-upload(
                :ratio='1'
                :src='item.render_plan_url'
                v-model='item.render_plan'
                label='Планировка без мебели'
              )
            v-flex(xs12 sm2)
              s-image-upload(
                :ratio='1'
                :src='item.render_view_url'
                v-model='item.render_view'
                label='Планировка с мебелью'
              )
            v-flex(xs12 sm2 style="background-color: #ebfbe9")
              s-image-upload(
                :ratio='1'
                :src='item.placement_3d_url'
                v-model='item.placement_3d'
                label='3D Планировка с мебелью'
              )
            v-flex(xs12 sm2)
            v-flex(xs12)
              v-divider(class='my-3')
            v-flex(xs12)
              s-sortable(
                @change='onFilesSort'
                @remove='onFileRemove'
                :sortable='item.renders_list'
                :openable='true'
                :deletable='true'
              )
            v-flex(xs12)
              dropzone(v-model='attachFiles' @error='onFileError')
    v-tab
      div
        span Связанные помещения
        span(v-if='layoutLinksCount>0') <b> {{ layoutLinksCount }}</b> шт.
    v-tab-item(:transition='false' :reverse-transition='false')
      v-card
        v-container(grid-list-xl fluid)
          v-layout(wrap)
            v-data-table(
              :hide-actions='true',
              :headers='headers'
              :items='layoutLinks'
            )
              template(slot='items', slot-scope='props')
                tr()
                  td {{ props.item.building_number }}
                  td {{ props.item.section_number }}
                  td {{ props.item.floor_numbers }}
                  td.text-xs-right.wrapless.crud-tools
                    v-btn(icon, @click='openLinkedFloor(props.item)')
                      v-icon(small) launch
    template(v-if='layoutId')
      v-tab Варианты планировки
      v-tab-item(:transition='false' :reverse-transition='false')
        v-card
          v-container(grid-list-xl fluid)
            v-layout(wrap)
              v-flex(xs12)
                s-sortable(
                  @change='onFilesSort'
                  @remove='onFileRemove'
                  :sortable='item.variants_list'
                  :openable='true'
                  :deletable='true'
                )
              v-flex(xs12)
                dropzone(v-model='attachedVariants' @error='onFileError')
  v-card-actions(class='large pr-0')
    v-spacer
    s-back-btn
    v-btn(
      @click='onSave'
      :loading='isLoading'
      color='primary'
      depressed
    ) Сохранить
</template>

<script>
import { isObject } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import http from '@/http'

export default {
  name: 'Edit',

  props: ['layoutId'],

  components: {
    Dropzone: () => import('@/components/async/Dropzone')
  },

  data: () => ({
    item: {},
    layoutLinks: [],
    attachFiles: {},
    attachedVariants: {},
    layoutLinksCount: 0,
    headers: [
      {
        text: 'Дом',
        align: 'left',
        value: 'building_number',
        width: '0%',
        sortable: false
      },
      {
        text: 'Подъезд',
        align: 'left',
        value: 'section_number',
        width: '0%',
        sortable: false
      },
      {
        text: 'Этажи',
        align: 'left',
        value: 'floor_numbers',
        width: '0%',
        sortable: false
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ]
  }),

  async mounted() {
    this.fetchLinks()
  },

  created() {
    this.updateItem()
  },

  methods: {
    async updateItem() {
      if (this.layoutId) {
        try {
          this.item = (await this.fetchSingle({ id: this.layoutId })).data
        } catch (e) {
          this.$root.showSnack('Ошибка загрузки планировки')
        }
      }
    },

    async fetchLinks() {
      if (this.layoutId) {
        try {
          const response = await http.get(`/complexes/placements-layouts/${this.layoutId}/apartments`)
          this.layoutLinks = response.data
          this.layoutLinksCount = this.layoutLinks.length
        } catch (e) {
          this.$root.showSnack('Ошибка загрузки свзанных планировок')
        }
      }
    },

    async onSave() {
      let data = this.createFormData()

      try {
        if (this.layoutId) {
          await this.update({
            id: this.layoutId,
            data
          })
        } else {
          await this.create({ data })
        }

        this.files = {}

        this.$nextTick(() => {
          this.$root.showSnack('Планировка сохранена')
          this.$router.push({ name: 'Complexes.Layouts' })
        })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },   

    onRemovePDF() {
      this.item.pdf_for_print = null
      this.item.pdf_for_print_url = null
    },

    createFormData() {
      let item = this.item
      let data = new FormData()

      Object.keys(item).forEach(key => {
        data.append(
          key,
          isObject(item[key]) ? JSON.stringify(item[key]) : item[key]
        )
      })
      data.append('attachFiles', Object.keys(this.attachFiles))
      data.append('attachedVariants', Object.keys(this.attachedVariants))
      return data
    },

    onImageRemove(imageKey) {
      this[imageKey] = null
    },

    onFileError() {
      this.$root.showSnack('Ошибка загрузки файла')
    },

    objectChange() {
      this.item.object_ids = []
    },

    openLinkedFloor(floor) {
      const routeData = this.$router.resolve({
        name: 'Complexes.Objects.Sections.Floors.Edit',
        params: {
          id: floor.complex_id,
          objectId: floor.object_id,
          sectionId: floor.section_id,
          floorId: floor.floor_id,
        }});
      window.open(routeData.href, '_blank');

    },

    async onFilesSort(files) {
      if (!this.isLoading) {
        try {
          await this.sortFiles(files)
        } catch (e) {
          this.$root.showSnack('Ошибка сортировки файлов')
        }
      }
    },

    async onFileRemove({ hash }) {
      if (!this.isLoading && (await this.$confirm('Вы уверены'))) {
        try {
          await this.removeFile(hash)
          this.updateItem()
        } catch (e) {
          this.$root.showSnack('Ошибка удаления файла')
        }
      }
    },

    ...mapActions('objects/layouts', [
      'fetchSingle',
      'update',
      'create',
      'sortFiles',
      'removeFile'
    ])
  },

  computed: {
    ...mapGetters('objects/layouts', ['isLoading'])
  }
}
</script>
